import React, { Fragment, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';

import { UserProfileModel } from 'client/data/models/profile/profile';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { EventToolbox } from 'client/utils/event-toolbox';
import { PAGE_CONTENT_UPDATE } from 'client/tracking/constant';

import { countTotalPages, filterUserVins } from 'site-modules/shared/utils/profile/dashboard-helper';
import { extractVinsWithLeads } from 'site-modules/shared/components/profile/utils/extract-helper';
import { markAlertAsViewed } from 'site-modules/shared/components/profile/price-drop-alerts/alerts-utils';

import { DashboardSpinner } from 'site-modules/profile/components/shared/dashboard-spinner/dashboard-spinner';
import { InsiderEmptyState } from 'site-modules/shared/components/profile/insider-empty-state/insider-empty-state';
import { VinCardsContainer } from 'site-modules/profile/components/dashboard/vin-cards-container/vin-cards-container';

const EMPTY_STATE_PROPS = {
  title: 'You haven’t saved any cars, yet!',
  subTitle: 'Start saving cars for sale to get price drop alerts!',
  buttonText: 'Find great deals near you',
  buttonHref: '/inventory/srp.html',
  trackingId: 'add_vehicle',
};

const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};

function VinCardsLandingComponent({ idmData = null, deleteVinFromIdm, compareSelect = null, updateIdmData }) {
  const [currentPage, setCurrentPage] = useState(1);

  const seeMoreClick = useCallback(() => {
    setCurrentPage(currentPage + 1);
  }, [currentPage]);

  const updatePriceDropAlerts = useCallback(() => {
    const alerts = get(idmData, 'alerts', EMPTY_ARRAY);
    const updatedAlerts = markAlertAsViewed(alerts);
    if (updatedAlerts.alerts.length) {
      updateIdmData(updatedAlerts);
    }
  }, [idmData, updateIdmData]);

  useEffect(() => {
    EventToolbox.fireCustomEvent(PAGE_CONTENT_UPDATE);
  }, []);

  const vinsWithLeads = extractVinsWithLeads(idmData);
  const savedVins = get(idmData, 'vehicles.vins', EMPTY_OBJECT);
  const savedDeals = get(idmData, 'edmundsDeals', EMPTY_ARRAY);
  const userVins = filterUserVins(savedVins);
  const showEmptyState = !userVins.length;
  const pages = countTotalPages(userVins);

  return idmData ? (
    <Fragment>
      {!showEmptyState && (
        <VinCardsContainer
          userVins={userVins}
          visibleSeeMoreButton={currentPage < pages}
          currentPage={currentPage}
          deleteVinFromIdm={deleteVinFromIdm}
          updatePriceDropAlerts={updatePriceDropAlerts}
          vinsWithLeads={vinsWithLeads}
          seeMoreClick={seeMoreClick}
          savedDeals={savedDeals}
          compareSelect={compareSelect}
        />
      )}
      {showEmptyState && <InsiderEmptyState {...EMPTY_STATE_PROPS} />}
    </Fragment>
  ) : (
    <DashboardSpinner />
  );
}

VinCardsLandingComponent.propTypes = {
  idmData: PropTypes.shape({
    vehicles: PropTypes.shape({
      vins: PropTypes.shape({}),
    }),
    alerts: PropTypes.arrayOf(PropTypes.shape({})),
    edmundsDeals: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  updateIdmData: PropTypes.func.isRequired,
  deleteVinFromIdm: PropTypes.func.isRequired,
  compareSelect: PropTypes.shape({}),
};

export const VinCardsLanding = connectToModel(VinCardsLandingComponent, {
  idmData: bindToPath(props => (props.isAuthenticated ? 'data.idm' : ''), UserProfileModel),
});
